module.exports = __webpack_public_path__ + "img/10_Distal Transverse Colon.1ab83cec.png";